import React from 'react';
import { TextInput, StyleSheet } from 'react-native';
import { useTheme } from '@/context/ThemeContext';

export default function OnboardingNameInput({
  value,
  onChangeText,
  placeholder = 'What should I call you?',
  autoFocus = false,
}) {
  const { colors } = useTheme();

  return (
    <TextInput
      value={value}
      onChangeText={onChangeText}
      placeholder={placeholder}
      placeholderTextColor={colors.text_color_tertiary}
      autoFocus={autoFocus}
      autoCapitalize="words"
      autoCorrect={false}
      style={[
        styles.input,
        {
          backgroundColor: colors.solid_color_tertiary,
          color: colors.text_color_primary,
          borderColor: colors.border_color_secondary,
        },
      ]}
    />
  );
}

const styles = StyleSheet.create({
  input: {
    fontSize: 16,
    padding: 14,
    borderRadius: 12,
    borderWidth: 1,
    width: '100%',
  },
});
